import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=1cffa6d2"
var script = {}
import style0 from "./hero.vue?vue&type=style&index=0&id=1cffa6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports